import { useEffect, useState } from 'react';
import { ALL_FONT_FAMILIES, resolveThemeFontHrefs } from '../../../utils/googleFonts';

const BASELINE_FONTS = ['monospace', 'serif', 'sans-serif'] as const;
const SAMPLE_GLYPHS = 'mmmmmwwwwwlliiOO';

const isFontLoaded = (family: string): boolean => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) {
    return false;
  }

  return BASELINE_FONTS.some((baseline) => {
    context.font = `72px ${baseline}`;
    const baselineWidth = context.measureText(SAMPLE_GLYPHS).width;
    context.font = `72px "${family}", ${baseline}`;
    const familyWidth = context.measureText(SAMPLE_GLYPHS).width;
    return familyWidth !== baselineWidth;
  });
};

const FontPreviewList = () => {
  const [loadedByFamily, setLoadedByFamily] = useState<Record<string, boolean>>({});

  useEffect(() => {
    resolveThemeFontHrefs(ALL_FONT_FAMILIES).forEach((href) => {
      if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    });
  }, []);

  useEffect(() => {
    let cancelled = false;
    const recompute = () => {
      const next: Record<string, boolean> = {};
      ALL_FONT_FAMILIES.forEach((family) => {
        next[family] = isFontLoaded(family);
      });
      if (!cancelled) {
        setLoadedByFamily(next);
      }
    };

    recompute();
    document.fonts.ready.then(() => {
      recompute();
      window.setTimeout(recompute, 1500);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div style={{ marginTop: 16, textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
      <strong>{'Font Renderer'}</strong>
      <div
        style={{
          maxHeight: 280,
          overflowY: 'auto',
          border: '1px solid #ccc',
          borderRadius: 4,
          padding: 8,
          background: '#fff',
        }}
      >
        {ALL_FONT_FAMILIES.map((family) => (
          <div
            key={family}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '4px 0',
              borderBottom: '1px solid #eee',
            }}
          >
            <span style={{ width: 20 }}>{loadedByFamily[family] ? '✅' : '❌'}</span>
            <span style={{ fontFamily: 'monospace', minWidth: 170, fontSize: 12, color: '#333' }}>
              {family}
            </span>
            <span style={{ fontFamily: `"${family}"`, fontSize: 20, color: '#000' }}>
              {`Aa Gg 123 — ${family}`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FontPreviewList;
